module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-edit/kiosk-edit.component.css
// module id = ./src/app/kiosk-edit/kiosk-edit.component.css
// module chunks = main